module.exports = __webpack_public_path__ + "img/actionGet2.f969ac9e.png";